export default __webpack_public_path__ + "static/media/home-img10.6bad591a.png";